var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller("cartController", [
    "$rootScope",
    "$scope",
    "$window",
    "$filter",
    "$sce",
    "$q",
    "$timeout",
    "storefrontApp.mainContext",
    "cartService",
    "catalogService",
    "urlService",
    "modalService",
    "commonService",
    "loaderService",
    "accountService",
    "productService",
    "shippingService",
    "elasticService",
    "membershipService",
    function (
        $rootScope,
        $scope,
        $window,
        $filter,
        $sce,
        $q,
        $timeout,
        storefrontAppMainContext,
        cartService,
        catalogService,
        urlService,
        modalService,
        commonService,
        loaderService,
        accountService,
        productService,
        shippingService,
        elasticService,
        membershipService
    ) {
        //#region Customer Watch
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function () {
                if (angular.isUndefined($scope.customer)) {
                    $scope.customer = storefrontAppMainContext.customer;
                }
            }
        );
        //#endregion

        //#region Catalog
        $scope.catalog = {
            productDefinition: catalogService.productDefinition,
        };
        //#endregion

        //#region Cart Variables
        $rootScope.isCartPage = true;
        $scope.shippingMethods = {
            showModal: false,
            cd: { usa: null, other: null },
            usb: { usa: null, other: null },
            formats: [],
            shippingMethodForm: null,
            shipACD: { format: null, shippingMethodName: "" },
        };
        //#endregion

        // #region Initialize Cart
        $scope.initialize = function () {
            // Get the URL for Continue Shopping button based on the last visited listing page.
            var prevListingPageURL = cookiesFactory.get(
                "COMMERCE_SITE_PreviousCatalogPage"
            );
            if (prevListingPageURL == null || prevListingPageURL == "''") {
                $scope.continueShoppingUrl = "/";
            } else {
                $scope.continueShoppingUrl = prevListingPageURL;
            }
        };
        // #endregion

        function applyFilter(filterName, value) {
            return $filter(filterName)(value);
        }

        //#region GET CART DETAILS
        $scope.getCart = function (isInitialLoad) {
            $scope.isCouponApplied = localStorage.getItem("IsCouponApplied");
            $scope.couponCode = localStorage.getItem("AppliedCoupon");
            loaderService.show();
            $scope.cartIsUpdating = true;
            if (
                $window.current_active_page !== "club_payment" ||
                $window.current_active_page === undefined
            ) {
                cartService
                    .moveListItemsToCart()
                    .then(function (response) {
                        return cartService.getCartForCheckout();
                    })
                    .then(
                        function (response) {
                            var cart = response.data;
                            $scope.GetPromotions(cart);
                            cart.hasValidationErrors =
                                _.some(cart.validationErrors) ||
                                _.some(cart.items, function (item) {
                                    return _.some(item.validationErrors);
                                });

                            $scope.cart = cart;
                            syncCouponStateFromCart(cart);

                            cartService
                                .getCartItemSchema()
                                .then(function (response) {
                                    // #region Generate Cart Item Content
                                    $scope.cart.items.forEach(function (item) {
                                        var html = "";
                                        angular.forEach(
                                            response.data,
                                            function (field) {
                                                try {
                                                    var label =
                                                        window.cartPageLocale[
                                                            field.label
                                                        ];

                                                    var definition =
                                                        angular.isDefined(
                                                            field.definition
                                                        )
                                                            ? field.definition
                                                                  .split(",")
                                                                  .map(
                                                                      function (
                                                                          def
                                                                      ) {
                                                                          return def
                                                                              .trim()
                                                                              .toLowerCase();
                                                                      }
                                                                  )
                                                            : [];

                                                    var definitionExcludes =
                                                        angular.isDefined(
                                                            field.definitionExcludes
                                                        )
                                                            ? field.definitionExcludes
                                                                  .split(",")
                                                                  .map(
                                                                      function (
                                                                          def
                                                                      ) {
                                                                          return def
                                                                              .trim()
                                                                              .toLowerCase();
                                                                      }
                                                                  )
                                                            : [];

                                                    var includedInDefinition =
                                                        definition.length > 0 &&
                                                        definition.indexOf(
                                                            item.definitionName.toLowerCase()
                                                        ) !== -1;
                                                    var excludedInDefinitionExcludes =
                                                        definitionExcludes.length >
                                                            0 &&
                                                        definitionExcludes.indexOf(
                                                            item.definitionName.toLowerCase()
                                                        ) == -1;

                                                    if (
                                                        includedInDefinition ||
                                                        excludedInDefinitionExcludes
                                                    ) {
                                                        var binding =
                                                            field.binding
                                                                ? field.binding
                                                                : "";
                                                        var bindingText =
                                                            field.bindingText
                                                                ? field.bindingText
                                                                : "";
                                                        var value = "";

                                                        if (binding) {
                                                            try {
                                                                var width =
                                                                    undefined;
                                                                var height =
                                                                    undefined;

                                                                if (
                                                                    binding.indexOf(
                                                                        "item.width"
                                                                    ) > -1 &&
                                                                    item.width >
                                                                        0
                                                                ) {
                                                                    width =
                                                                        applyFilter(
                                                                            "mmToinches",
                                                                            item.width
                                                                        );
                                                                }

                                                                if (
                                                                    binding.indexOf(
                                                                        "item.height"
                                                                    ) > -1 &&
                                                                    item.height >
                                                                        0
                                                                ) {
                                                                    height =
                                                                        applyFilter(
                                                                            "mmToinches",
                                                                            item.height
                                                                        );
                                                                }

                                                                if (
                                                                    binding.indexOf(
                                                                        "|"
                                                                    ) > -1 &&
                                                                    binding
                                                                        .toLowerCase()
                                                                        .indexOf(
                                                                            "fabriclength"
                                                                        ) >
                                                                        -1 &&
                                                                    item &&
                                                                    !item.multipleVariants
                                                                ) {
                                                                    var filters =
                                                                        binding.split(
                                                                            "|"
                                                                        );
                                                                    if (
                                                                        filters &&
                                                                        filters.length >
                                                                            1
                                                                    ) {
                                                                        for (
                                                                            var i =
                                                                                filters.length -
                                                                                1;
                                                                            i >
                                                                            0;
                                                                            i--
                                                                        ) {
                                                                            value =
                                                                                applyFilter(
                                                                                    filters[
                                                                                        i
                                                                                    ].trim(),
                                                                                    eval(
                                                                                        filters[0].trim()
                                                                                    )
                                                                                );
                                                                        }
                                                                    }
                                                                    if (
                                                                        binding
                                                                            .toLowerCase()
                                                                            .indexOf(
                                                                                "fabriclength"
                                                                            ) >
                                                                            -1 &&
                                                                        parseFloat(
                                                                            value
                                                                        ) > 0
                                                                    ) {
                                                                        value +=
                                                                            " yard";
                                                                    }
                                                                }

                                                                if (
                                                                    angular.isDefined(
                                                                        width
                                                                    ) &&
                                                                    angular.isDefined(
                                                                        height
                                                                    )
                                                                ) {
                                                                    value =
                                                                        width +
                                                                        '" W x ' +
                                                                        height +
                                                                        '" H';
                                                                } else if (
                                                                    angular.isDefined(
                                                                        width
                                                                    )
                                                                ) {
                                                                    value =
                                                                        width +
                                                                        '" W';
                                                                } else if (
                                                                    angular.isDefined(
                                                                        height
                                                                    )
                                                                ) {
                                                                    value =
                                                                        height +
                                                                        '" H';
                                                                } else if (
                                                                    value === ""
                                                                ) {
                                                                    value =
                                                                        eval(
                                                                            binding
                                                                        );
                                                                }
                                                            } catch (e) {
                                                                value = "";
                                                            }
                                                        }

                                                        if (bindingText) {
                                                            value =
                                                                window
                                                                    .cartPageLocale[
                                                                    bindingText
                                                                ];
                                                        }
                                                        if (
                                                            angular.isUndefined(
                                                                field.case
                                                            ) ||
                                                            (angular.isDefined(
                                                                field.case
                                                            ) &&
                                                                field.case.toLowerCase() !==
                                                                    "neutral")
                                                        ) {
                                                            value =
                                                                value.toUpperCase();
                                                        }

                                                        if (
                                                            value.length > 1 ||
                                                            (!isNaN(
                                                                parseFloat(
                                                                    value
                                                                )
                                                            ) &&
                                                                parseFloat(
                                                                    value
                                                                ) > 0)
                                                        ) {
                                                            html +=
                                                                '<div class="flex">' +
                                                                '<span class="label">' +
                                                                label +
                                                                ":</span>" +
                                                                '<span class="det" title="' +
                                                                value +
                                                                '">' +
                                                                value +
                                                                "</span></div>";
                                                        }
                                                        if (
                                                            binding.indexOf(
                                                                "|"
                                                            ) > -1 &&
                                                            binding
                                                                .toLowerCase()
                                                                .indexOf(
                                                                    "multiplevariants"
                                                                ) > -1 &&
                                                            item &&
                                                            item.multipleVariants
                                                        ) {
                                                            // Split item.multipleVariants into labels and values
                                                            var variants =
                                                                item.multipleVariants.split(
                                                                    "|"
                                                                );
                                                            variants.forEach(
                                                                function (
                                                                    variant
                                                                ) {
                                                                    var parts =
                                                                        variant.split(
                                                                            "-"
                                                                        );
                                                                    if (
                                                                        parts.length ===
                                                                        2
                                                                    ) {
                                                                        var label =
                                                                            parts[0].trim();
                                                                        var value =
                                                                            parts[1].trim();

                                                                        html +=
                                                                            '<div class="flex">' +
                                                                            '<span class="label">' +
                                                                            label +
                                                                            ":</span>" +
                                                                            '<span class="det" title="' +
                                                                            value +
                                                                            '">' +
                                                                            value +
                                                                            "</span>" +
                                                                            "</div>";
                                                                    }
                                                                }
                                                            );
                                                        }

                                                        // Handle personalized design size
                                                        if (
                                                            item.definitionName.toLowerCase() ===
                                                                "personalizeddesign" &&
                                                            (label
                                                                .toLowerCase()
                                                                .trim() ===
                                                                "custom size" ||
                                                                label
                                                                    .toLowerCase()
                                                                    .trim() ===
                                                                    "size") &&
                                                            item.cartLineItemCustomProperties &&
                                                            item
                                                                .cartLineItemCustomProperties
                                                                .length > 0
                                                        ) {
                                                            var pdProps =
                                                                item
                                                                    .cartLineItemCustomProperties[0];
                                                            var sizeValue = "";
                                                            var sizeValueTitle =
                                                                ""; // Plain text for title attribute

                                                            if (
                                                                pdProps.pdHoopSize !=
                                                                    null &&
                                                                pdProps.pdHoopSize !==
                                                                    ""
                                                            ) {
                                                                // Lettering personalization
                                                                var pdAddText = (
                                                                    pdProps.pdAddText ||
                                                                    ""
                                                                ).trim();
                                                                if (pdAddText) {
                                                                    label =
                                                                        "Text Added";
                                                                    var escAdd = function (s) {
                                                                        return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                                                                    };
                                                                    sizeValue =
                                                                        escAdd(pdAddText);
                                                                    sizeValueTitle =
                                                                        pdAddText;
                                                                } else {
                                                                    label =
                                                                        "Text Replaced";
                                                                    var r1 = (
                                                                        pdProps.pdReplaceText1 ||
                                                                        ""
                                                                    ).trim();
                                                                    var n1 = (
                                                                        pdProps.pdNewText1 ||
                                                                        ""
                                                                    ).trim();
                                                                    var r2 = (
                                                                        pdProps.pdReplaceText2 ||
                                                                        ""
                                                                    ).trim();
                                                                    var n2 = (
                                                                        pdProps.pdNewText2 ||
                                                                        ""
                                                                    ).trim();
                                                                    var esc = function (s) {
                                                                        return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                                                                    };
                                                                    var parts =
                                                                        [];
                                                                    if (r1 && n1)
                                                                        parts.push(
                                                                            '1. "' +
                                                                                esc(r1) +
                                                                                '" → "' +
                                                                                esc(n1) +
                                                                                '"'
                                                                        );
                                                                    if (r2 && n2)
                                                                        parts.push(
                                                                            '2. "' +
                                                                                esc(r2) +
                                                                                '" → "' +
                                                                                esc(n2) +
                                                                                '"'
                                                                        );
                                                                    sizeValue =
                                                                        parts.join(
                                                                            "<br/>"
                                                                        );
                                                                    sizeValueTitle =
                                                                        parts.join(" ");
                                                                }
                                                            } else {
                                                                // Resize personalization
                                                                label =
                                                                    '<span class="desktop-text">Custom Size</span><span class="mobile-text">Size</span>';

                                                                if (
                                                                    pdProps.pdIsCap ===
                                                                    true
                                                                ) {
                                                                var capText =
                                                                    '<span class="desktop-text responsive-text">Optimized For Cap</span><span class="mobile-text responsive-text">Cap Size</span>';
                                                                sizeValue =
                                                                    capText;
                                                                sizeValueTitle =
                                                                    "Optimized For Cap"; // Plain text for title
                                                            } else if (
                                                                pdProps.pdIsProportionalHeight ===
                                                                true
                                                            ) {
                                                                var pdWidth =
                                                                    parseFloat(
                                                                        pdProps.pdWidth
                                                                    ) || 0;
                                                                if (
                                                                    pdWidth > 0
                                                                ) {
                                                                    var optimizedHText =
                                                                        '<span class="desktop-text responsive-text">Optimized H</span><span class="mobile-text responsive-text">Opt. H</span>';
                                                                    sizeValue =
                                                                        pdWidth +
                                                                        '" W x ' +
                                                                        optimizedHText;
                                                                    sizeValueTitle =
                                                                        pdWidth +
                                                                        '" W x Optimized H'; // Plain text for title
                                                                }
                                                            } else if (
                                                                pdProps.pdIsProportionalWidth ===
                                                                true
                                                            ) {
                                                                var pdHeight =
                                                                    parseFloat(
                                                                        pdProps.pdHeight
                                                                    ) || 0;
                                                                if (
                                                                    pdHeight > 0
                                                                ) {
                                                                    var optimizedHText =
                                                                        '<span class="desktop-text responsive-text">Optimized W</span><span class="mobile-text responsive-text">Opt. W</span>';
                                                                    sizeValue =
                                                                        pdHeight +
                                                                        '" H x ' +
                                                                        optimizedHText;
                                                                    sizeValueTitle =
                                                                        pdHeight +
                                                                        '" H x Optimized W'; // Plain text for title
                                                                }
                                                            } else {
                                                                var pdWidth =
                                                                    parseFloat(
                                                                        pdProps.pdWidth
                                                                    ) || 0;
                                                                var pdHeight =
                                                                    parseFloat(
                                                                        pdProps.pdHeight
                                                                    ) || 0;
                                                                if (
                                                                    pdWidth >
                                                                        0 &&
                                                                    pdHeight > 0
                                                                ) {
                                                                    sizeValue =
                                                                        pdWidth +
                                                                        '" W x ' +
                                                                        pdHeight +
                                                                        '" H';
                                                                    sizeValueTitle =
                                                                        sizeValue; // Plain text for title
                                                                } else if (
                                                                    (!pdWidth ||
                                                                        pdWidth <=
                                                                            0) &&
                                                                    pdHeight > 0
                                                                ) {
                                                                    sizeValue =
                                                                        pdHeight +
                                                                        '" H';
                                                                    sizeValueTitle =
                                                                        sizeValue; // Plain text for title
                                                                } else if (
                                                                    pdWidth >
                                                                        0 &&
                                                                    (!pdHeight ||
                                                                        pdHeight <=
                                                                            0)
                                                                ) {
                                                                    sizeValue =
                                                                        pdWidth +
                                                                        '" W';
                                                                    sizeValueTitle =
                                                                        sizeValue; // Plain text for title
                                                                }
                                                            }
                                                            }

                                                            if (sizeValue) {
                                                                var titleValue =
                                                                    sizeValueTitle ||
                                                                    sizeValue; // Use title value if available, fallback to sizeValue
                                                                var isLettering =
                                                                    pdProps.pdHoopSize != null &&
                                                                    pdProps.pdHoopSize !== "";
                                                                if (isLettering) {
                                                                    // Label on first line, full value on next line (no truncation). sizeValue may contain <br/> for line breaks.
                                                                    html +=
                                                                        '<div class="flex">' +
                                                                        '<span class="label">' +
                                                                        label +
                                                                        ":</span></div>" +
                                                                        '<div class="flex flex-wrap">' +
                                                                        '<span class="det det-pd-value" title="' +
                                                                        titleValue.replace(/'/g, "&#39;") +
                                                                        '">' +
                                                                        sizeValue +
                                                                        "</span></div>";
                                                                } else {
                                                                    html +=
                                                                        '<div class="flex">' +
                                                                        '<span class="label">' +
                                                                        label +
                                                                        ":</span>" +
                                                                        '<span class="det" title="' +
                                                                        titleValue +
                                                                        '">' +
                                                                        sizeValue +
                                                                        "</span></div>";
                                                                }
                                                            }
                                                        }
                                                    }
                                                } catch (err) {}
                                            }
                                        );
                                        item.generatedHtml =
                                            $sce.trustAsHtml(html);
                                        item.maxEligibleQuantity =
                                            item.definitionName.toLowerCase() ==
                                            "embroiderypatch"
                                                ? 10
                                                : 99;
                                    });
                                });

                            //#endregion Generate Cart Item Content

                            $scope.checkItemsInCustomPack();
                            $scope.isPinnacleOfferEligible();
                            $scope.getPotentialDiscounts();
                            $scope.getBuyXPercentOffNudges();
                            loaderService.hide();

                            //#region Shippable Product Inventory check
                            if ($scope.cartHasPhysicalProduct()) {
                                $scope.showOutOfStocklbl = false;
                                getProductsInventory();
                            } else {
                                $scope.showOutOfStocklbl = false;
                            }
                            //#endregion

                            //#region Check Cart is Valid
                            //Cart Limit is not Exceeded + Free Designs Limit is not exceeded
                            $scope.noOfitemslimit = cart.cartItemLimit
                                .toString()
                                .replace("-", "");
                            $scope.noOfFreeDesignsExceeding =
                                cart.freeDesignsUserCanOrder;
                            //#endregion

                            $scope.subTotal =
                                cart.subTotal.amount -
                                cart.discountTotal.amount;
                            $scope.$watch(
                                "subTotal",
                                function (newValue, oldValue) {
                                    updateCartPaypalAmount(newValue, oldValue);
                                }
                            );

                            $scope.cartIsUpdating = false;
                            $rootScope.$emit("RefreshCurrencyConversion");
                            if (
                                angular.isDefined(cart.customer) &&
                                angular.isDefined(cart.customer.userGroups)
                            ) {
                                $scope.isCircleMember =
                                    cart.customer.userGroups.some(function (
                                        elm
                                    ) {
                                        if (elm.toLowerCase() == "clubmember") {
                                            return true;
                                        }
                                    });
                            }
                            if (
                                !$scope.isCircleMember &&
                                cart.items.length > 0
                            ) {
                                getClubPriceTotal();
                            }

                            //GA 4
                            if (
                                typeof gtag !== "undefined" &&
                                gtag !== null &&
                                cart != null &&
                                isInitialLoad
                            ) {
                                //GA 4
                                cartObj = {
                                    currency: "USD",
                                    affiliation: "EmbroideryDesigns.com",
                                    value: cart.subTotal.amount,
                                    items: [],
                                };

                                if (
                                    cart.items != null &&
                                    cart.items.length > 0
                                ) {
                                    cart.items.forEach(function (item) {
                                        cartObj.items.push({
                                            item_name: item.name,
                                            item_id: item.sku,
                                            price: item.placedPrice.amount,
                                            item_category: item.definitionName,
                                            quantity: item.quantity,
                                        });
                                    });
                                }

                                gtag("event", "view_cart", cartObj);
                                if (typeof window.trackBing === "function") {
                                    window.trackBing("view_cart", {
                                        revenue_value: cart.subTotal.amount,
                                        currency: "USD",
                                    });
                                }
                            }

                            if ($scope.cartHasEmbrillianceProduct()) {
                                loadEmbrillianceCartRecommendations();
                            } else {
                                $scope.embrillianceCartFontPacks = [];
                                $scope.embrillianceCartBundles = [];
                            }

                            /* productService.getActiveCouponSales().then(function(couponResponse){
                            $scope.activeCoupons = couponResponse.data;
                        }) */
                        },
                        function (response) {
                            $scope.cartIsUpdating = false;
                        }
                    );
            }
        };
        //#endregion

        //  #region Promotions & Discounts
        $scope.getPotentialDiscounts = function () {
            cartService
                .checkPotentialShippingDiscounts()
                .then(function (response) {
                    if (
                        response != null &&
                        response.data != null &&
                        response.data.length > 0
                    ) {
                        $scope.potentialDiscounts = response.data;
                    } else {
                        $scope.potentialDiscounts = [];
                    }
                });
        };

        $scope.buyXPercentOffNudgesByLineItemId = {};

        $scope.getBuyXPercentOffNudges = function () {
            if (
                !$scope.cart ||
                !$scope.cart.items ||
                $scope.cart.items.length === 0
            ) {
                $scope.buyXPercentOffNudgesByLineItemId = {};
                return;
            }

            var cartItems = $scope.cart.items.map(function (item) {
                return {
                    lineItemId: item.id,
                    productId: item.productId,
                    extendedListPrice:
                        item.extendedListPrice &&
                        item.extendedListPrice.amount != null
                            ? item.extendedListPrice.amount
                            : 0,
                    quantity: item.quantity,
                };
            });

            cartService.getBuyXPercentOffNudges(cartItems).then(function (response) {
                var nudgesByLineItemId = {};
                if (response && response.data && response.data.length > 0) {
                    response.data.forEach(function (nudge) {
                        if (nudge && nudge.lineItemId) {
                            nudgesByLineItemId[nudge.lineItemId] = nudge;
                        }
                    });
                }
                $scope.buyXPercentOffNudgesByLineItemId = nudgesByLineItemId;
            });
        };

        $scope.getBuyXPercentOffNudge = function (item) {
            if (
                !item ||
                !$scope.buyXPercentOffNudgesByLineItemId ||
                !$scope.buyXPercentOffNudgesByLineItemId[item.id]
            ) {
                return null;
            }
            return $scope.buyXPercentOffNudgesByLineItemId[item.id];
        };

        $scope.getBuyXPercentOffNudgeSaleUrl = function (nudge) {
            if (!nudge || !nudge.saleUrl) {
                return "";
            }
            var saleUrl = (nudge.saleUrl + "").trim();
            if (/^https?:\/\//i.test(saleUrl)) {
                return saleUrl;
            }
            var base = (
                ($scope.baseUrl || $rootScope.baseUrl || "") + ""
            ).replace(/\/+$/, "");
            if (!base) {
                return saleUrl.charAt(0) === "/" ? saleUrl : "/" + saleUrl;
            }
            return (
                base +
                (saleUrl.charAt(0) === "/" ? saleUrl : "/" + saleUrl)
            );
        };

        $scope.getBrandListingPageUrl = function (brand) {
            return "all/catalog/" + brand.toLowerCase().replace(/ /g, "-");
        };

        $scope.GetPromotions = function (cart) {
            $scope.appliedDiscounts = [];
            var addedCartPromotionIds = {}; // Object to keep track of added promotionId
            if (cart.items.length > 0) {
                // For item level promotions
                cart.items.forEach(function (cartItem) {
                    if (cartItem.discounts.length > 0) {
                        cartItem.discounts.forEach(function (discount) {
                            if (
                                discount.amount.amount > 0 &&
                                !addedCartPromotionIds[discount.promotionId]
                            ) {
                                discount.amount.amount =
                                    discount.amount.amount *
                                    (angular.isNumber(cartItem.quantity)
                                        ? cartItem.quantity
                                        : 1);
                                $scope.appliedDiscounts.push(discount);
                            }
                        });
                    }
                });
                $scope.promotions = [];
                $scope.appliedDiscounts.forEach(function (discount) {
                    var index = -1;
                    for (var i = 0; i < $scope.promotions.length; i++) {
                        if (
                            $scope.promotions[i].promotionId ==
                            discount.promotionId
                        ) {
                            index = i;
                            break;
                        }
                    }
                    if (index < 0) {
                        $scope.promotions.push(discount);
                    } else {
                        $scope.promotions[index].amount.amount +=
                            discount.amount.amount;
                    }
                });
                // For cart level sales & promotions
                var addedPromotionIds = {}; // Object to keep track of added promotionIds

                cart.discounts.forEach(function (discount) {
                    if (
                        discount.amount.amount > 0 &&
                        !addedPromotionIds[discount.promotionId]
                    ) {
                        $scope.promotions.push(discount);
                        addedPromotionIds[discount.promotionId] = true; // Mark this promotionId as added
                    }
                });
            }
        };

        $scope.checkItemsInCustomPack = function () {
            cartService.checkItemsInCustomPack().then(function (response) {
                $scope.customPackCondition = response.data;
            });
        };
        // #endregion

        //#region Coupons

        function hasCouponDiscount(cart, couponCode) {
            if (!cart || !couponCode) {
                return false;
            }

            var code = couponCode.toLowerCase();

            function discountMatches(discount) {
                return (
                    discount &&
                    discount.amount &&
                    discount.amount.amount > 0 &&
                    discount.coupon &&
                    discount.coupon.toLowerCase() === code
                );
            }

            if (cart.discounts && cart.discounts.some(discountMatches)) {
                return true;
            }

            if (!cart.items) {
                return false;
            }

            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                if (item.discounts && item.discounts.some(discountMatches)) {
                    return true;
                }
            }

            return false;
        }

        function isCouponEffectivelyApplied(cart) {
            if (!cart.coupons || cart.coupons.length === 0) {
                return false;
            }

            var coupon = cart.coupons[0];
            if (!coupon.code || !coupon.appliedSuccessfully) {
                return false;
            }

            if (hasCouponDiscount(cart, coupon.code)) {
                return true;
            }

            return cart.discountTotal && cart.discountTotal.amount > 0;
        }

        function clearCouponAppliedState() {
            $scope.appliedCoupon = null;
            $scope.couponValid = false;
            $scope.coupon = null;
            $scope.applyCoupon = false;
            $scope.removeCoupon();
        }

        function syncCouponStateFromCart(cart) {
            if (isCouponEffectivelyApplied(cart)) {
                $scope.applyCoupon = true;
                $scope.appliedCoupon = cart.coupons[0].code;
                $scope.couponValid = true;
                return;
            }

            clearCouponAppliedState();
        }

        $scope.removeCoupon = function () {
            localStorage.removeItem("IsCouponApplied");
            localStorage.removeItem("AppliedCoupon");
        };

        // Common function to refresh cart after coupon operations
        $scope.refreshCartAfterCouponOperation = function () {
            return cartService.getCartForCheckout().then(function (response) {
                var cart = response.data;

                // Update cart state
                $scope.GetPromotions(cart);
                cart.hasValidationErrors =
                    _.some(cart.validationErrors) ||
                    _.some(cart.items, function (item) {
                        return _.some(item.validationErrors);
                    });

                $scope.cart = cart;
                $scope.subTotal =
                    cart.subTotal.amount - cart.discountTotal.amount;

                syncCouponStateFromCart(cart);

                cartService.getCartItemSchema().then(function (response) {
                    // #region Pre-process schema fields for performance
                    var schemaFields = response.data;
                    var processedFields = [];
                    var i, field, defStr, exclStr, defSet, exclSet;

                    // Pre-process all fields once
                    for (i = 0; i < schemaFields.length; i++) {
                        field = schemaFields[i];
                        defStr = field.definition || "";
                        exclStr = field.definitionExcludes || "";

                        // Convert to Sets for O(1) lookup instead of O(n) indexOf
                        defSet = defStr
                            ? new Set(
                                  defStr.split(",").map(function (def) {
                                      return def.trim().toLowerCase();
                                  })
                              )
                            : null;
                        exclSet = exclStr
                            ? new Set(
                                  exclStr.split(",").map(function (def) {
                                      return def.trim().toLowerCase();
                                  })
                              )
                            : null;

                        var bindingStr = field.binding || "";
                        var bindingLower = bindingStr.toLowerCase();
                        processedFields.push({
                            field: field,
                            label: window.cartPageLocale[field.label],
                            labelLower: (
                                window.cartPageLocale[field.label] || ""
                            ).toLowerCase(),
                            definitionSet: defSet,
                            definitionExcludesSet: exclSet,
                            binding: bindingStr,
                            bindingText: field.bindingText || "",
                            hasNeutralCase:
                                angular.isDefined(field.case) &&
                                field.case.toLowerCase() === "neutral",
                            bindingLower: bindingLower,
                            hasWidthBinding:
                                bindingStr.indexOf("item.width") > -1,
                            hasHeightBinding:
                                bindingStr.indexOf("item.height") > -1,
                            hasPipeBinding: bindingStr.indexOf("|") > -1,
                            hasFabricLength:
                                bindingLower.indexOf("fabriclength") > -1,
                            hasMultipleVariants:
                                bindingLower.indexOf("multiplevariants") > -1,
                            // Pre-split filters if pipe binding exists
                            filtersArray:
                                bindingStr.indexOf("|") > -1
                                    ? bindingStr.split("|")
                                    : null,
                        });
                    }
                    // #endregion

                    // #region Generate Cart Item Content
                    var items = $scope.cart.items;
                    var item,
                        j,
                        processedField,
                        htmlParts,
                        itemDefName,
                        itemDefNameLower;
                    var width,
                        height,
                        value,
                        binding,
                        bindingText,
                        label,
                        filters;
                    var pdProps, sizeValue, sizeValueTitle, titleValue;
                    var pdWidth, pdHeight, optimizedHText, capText;
                    var variants, variant, parts, variantLabel, variantValue;
                    var includedInDefinition, excludedInDefinitionExcludes;
                    var labelLowerTrim, valueNum, isValidValue;

                    for (i = 0; i < items.length; i++) {
                        item = items[i];
                        htmlParts = [];
                        itemDefName = item.definitionName;
                        itemDefNameLower = itemDefName
                            ? itemDefName.toLowerCase()
                            : "";

                        // Cache item properties
                        var itemWidth = item.width;
                        var itemHeight = item.height;
                        var itemMultipleVariants = item.multipleVariants;
                        var itemCartLineItemCustomProperties =
                            item.cartLineItemCustomProperties;

                        for (j = 0; j < processedFields.length; j++) {
                            processedField = processedFields[j];
                            label = processedField.label;

                            try {
                                // Fast definition matching using Sets
                                includedInDefinition =
                                    processedField.definitionSet
                                        ? processedField.definitionSet.has(
                                              itemDefNameLower
                                          )
                                        : false;
                                excludedInDefinitionExcludes =
                                    processedField.definitionExcludesSet
                                        ? !processedField.definitionExcludesSet.has(
                                              itemDefNameLower
                                          )
                                        : false;
                                if (
                                    !includedInDefinition &&
                                    !excludedInDefinitionExcludes
                                ) {
                                    continue; // Skip early if field doesn't match
                                }

                                binding = processedField.binding;
                                bindingText = processedField.bindingText;
                                value = "";

                                if (binding) {
                                    try {
                                        width = undefined;
                                        height = undefined;

                                        // Use pre-computed flags
                                        if (
                                            processedField.hasWidthBinding &&
                                            itemWidth > 0
                                        ) {
                                            width = applyFilter(
                                                "mmToinches",
                                                itemWidth
                                            );
                                        }

                                        if (
                                            processedField.hasHeightBinding &&
                                            itemHeight > 0
                                        ) {
                                            height = applyFilter(
                                                "mmToinches",
                                                itemHeight
                                            );
                                        }

                                        if (
                                            processedField.hasPipeBinding &&
                                            processedField.hasFabricLength &&
                                            item &&
                                            !itemMultipleVariants
                                        ) {
                                            // Use pre-split filters array
                                            filters =
                                                processedField.filtersArray;
                                            if (filters && filters.length > 1) {
                                                for (
                                                    var k = filters.length - 1;
                                                    k > 0;
                                                    k--
                                                ) {
                                                    value = applyFilter(
                                                        filters[k].trim(),
                                                        eval(filters[0].trim())
                                                    );
                                                }
                                            }
                                            if (
                                                processedField.hasFabricLength &&
                                                parseFloat(value) > 0
                                            ) {
                                                value += " yard";
                                            }
                                        }

                                        if (
                                            width !== undefined &&
                                            height !== undefined
                                        ) {
                                            value =
                                                width +
                                                '" W x ' +
                                                height +
                                                '" H';
                                        } else if (width !== undefined) {
                                            value = width + '" W';
                                        } else if (height !== undefined) {
                                            value = height + '" H';
                                        } else if (value === "") {
                                            value = eval(binding);
                                        }
                                    } catch (e) {
                                        value = "";
                                    }
                                }

                                if (bindingText) {
                                    value = window.cartPageLocale[bindingText];
                                }

                                if (!processedField.hasNeutralCase) {
                                    value = value.toUpperCase();
                                }

                                // Cache parseFloat result to avoid double calculation
                                var valueNum = parseFloat(value);
                                var isValidValue =
                                    value.length > 1 ||
                                    (!isNaN(valueNum) && valueNum > 0);
                                if (isValidValue) {
                                    htmlParts.push(
                                        '<div class="flex"><span class="label">' +
                                            label +
                                            ':</span><span class="det" title="' +
                                            value +
                                            '">' +
                                            value +
                                            "</span></div>"
                                    );
                                }

                                if (
                                    processedField.hasPipeBinding &&
                                    processedField.hasMultipleVariants &&
                                    item &&
                                    itemMultipleVariants
                                ) {
                                    // Split item.multipleVariants into labels and values
                                    variants = itemMultipleVariants.split("|");
                                    for (var v = 0; v < variants.length; v++) {
                                        variant = variants[v];
                                        parts = variant.split("-");
                                        if (parts.length === 2) {
                                            variantLabel = parts[0].trim();
                                            variantValue = parts[1].trim();

                                            htmlParts.push(
                                                '<div class="flex"><span class="label">' +
                                                    variantLabel +
                                                    ':</span><span class="det" title="' +
                                                    variantValue +
                                                    '">' +
                                                    variantValue +
                                                    "</span></div>"
                                            );
                                        }
                                    }
                                }

                                // Handle personalized design size
                                var labelLowerTrim =
                                    processedField.labelLower.trim();
                                if (
                                    itemDefNameLower === "personalizeddesign" &&
                                    (labelLowerTrim === "custom size" ||
                                        labelLowerTrim === "size") &&
                                    itemCartLineItemCustomProperties &&
                                    itemCartLineItemCustomProperties.length > 0
                                ) {
                                    pdProps =
                                        itemCartLineItemCustomProperties[0];
                                    sizeValue = "";
                                    sizeValueTitle = "";
                                    if (
                                        pdProps.pdHoopSize != null &&
                                        pdProps.pdHoopSize !== ""
                                    ) {
                                        // Lettering personalization
                                        var pdAddTextCart = (
                                            pdProps.pdAddText || ""
                                        ).trim();
                                        if (pdAddTextCart) {
                                            label = "Text Added";
                                            var escAddCart = function (s) {
                                                return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                                            };
                                            sizeValue = escAddCart(pdAddTextCart);
                                            sizeValueTitle = pdAddTextCart;
                                        } else {
                                            label = "Text Replaced";
                                            var r1Cart = (
                                                pdProps.pdReplaceText1 || ""
                                            ).trim();
                                            var n1Cart = (
                                                pdProps.pdNewText1 || ""
                                            ).trim();
                                            var r2Cart = (
                                                pdProps.pdReplaceText2 || ""
                                            ).trim();
                                            var n2Cart = (
                                                pdProps.pdNewText2 || ""
                                            ).trim();
                                            var escCart = function (s) {
                                                return (s + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
                                            };
                                            var partsCart = [];
                                            if (r1Cart && n1Cart)
                                                partsCart.push(
                                                    '1. "' +
                                                        escCart(r1Cart) +
                                                        '" → "' +
                                                        escCart(n1Cart) +
                                                        '"'
                                                );
                                            if (r2Cart && n2Cart)
                                                partsCart.push(
                                                    '2. "' +
                                                        escCart(r2Cart) +
                                                        '" → "' +
                                                        escCart(n2Cart) +
                                                        '"'
                                                );
                                            sizeValue = partsCart.join("<br/>");
                                            sizeValueTitle = partsCart.join(" ");
                                        }
                                    } else {
                                        // Resize personalization
                                        label =
                                            '<span class="desktop-text">Custom Size</span><span class="mobile-text">Size</span>';

                                        if (pdProps.pdIsCap === true) {
                                        capText =
                                            '<span class="desktop-text responsive-text">Optimized For Cap</span><span class="mobile-text responsive-text">Cap Size</span>';
                                        sizeValue = capText;
                                        sizeValueTitle = "Optimized For Cap";
                                    } else if (
                                        pdProps.pdIsProportionalHeight === true
                                    ) {
                                        pdWidth =
                                            parseFloat(pdProps.pdWidth) || 0;
                                        if (pdWidth > 0) {
                                            optimizedHText =
                                                '<span class="desktop-text responsive-text">Optimized H</span><span class="mobile-text responsive-text">Opt. H</span>';
                                            sizeValue =
                                                pdWidth +
                                                '" W x ' +
                                                optimizedHText;
                                            sizeValueTitle =
                                                pdWidth + '" W x Optimized H';
                                        }
                                    } else if (
                                        pdProps.pdIsProportionalWidth === true
                                    ) {
                                        pdHeight =
                                            parseFloat(pdProps.pdHeight) || 0;
                                        if (pdHeight > 0) {
                                            optimizedHText =
                                                '<span class="desktop-text responsive-text">Optimized W</span><span class="mobile-text responsive-text">Opt. W</span>';
                                            sizeValue =
                                                pdHeight +
                                                '" H x ' +
                                                optimizedHText;
                                            sizeValueTitle =
                                                pdHeight + '" H x Optimized W';
                                        }
                                    } else {
                                        pdWidth =
                                            parseFloat(pdProps.pdWidth) || 0;
                                        pdHeight =
                                            parseFloat(pdProps.pdHeight) || 0;
                                        if (pdWidth > 0 && pdHeight > 0) {
                                            sizeValue =
                                                pdWidth +
                                                '" W x ' +
                                                pdHeight +
                                                '" H';
                                            sizeValueTitle = sizeValue;
                                        } else if (
                                            (!pdWidth || pdWidth <= 0) &&
                                            pdHeight > 0
                                        ) {
                                            sizeValue = pdHeight + '" H';
                                            sizeValueTitle = sizeValue;
                                        } else if (
                                            pdWidth > 0 &&
                                            (!pdHeight || pdHeight <= 0)
                                        ) {
                                            sizeValue = pdWidth + '" W';
                                            sizeValueTitle = sizeValue;
                                        }
                                    }
                                    }

                                    if (sizeValue) {
                                        titleValue =
                                            sizeValueTitle || sizeValue;
                                        var isLetteringCart =
                                            pdProps.pdHoopSize != null &&
                                            pdProps.pdHoopSize !== "";
                                        if (isLetteringCart) {
                                            // Label on first line, full value on next line (no truncation)
                                            htmlParts.push(
                                                '<div class="flex"><span class="label">' +
                                                    label +
                                                    ":</span></div>"
                                            );
                                            var safeTitle = (titleValue + "").replace(/'/g, "&#39;");
                                            htmlParts.push(
                                                '<div class="flex flex-wrap"><span class="det det-pd-value" title="' +
                                                    safeTitle +
                                                    '">' +
                                                    sizeValue +
                                                    "</span></div>"
                                            );
                                        } else {
                                            htmlParts.push(
                                                '<div class="flex"><span class="label">' +
                                                    label +
                                                    ':</span><span class="det" title="' +
                                                    titleValue +
                                                    '">' +
                                                    sizeValue +
                                                    "</span></div>"
                                            );
                                        }
                                    }
                                }
                            } catch (err) {
                                // Silently continue on error
                            }
                        }

                        // Use array.join() instead of string concatenation
                        item.generatedHtml = $sce.trustAsHtml(
                            htmlParts.join("")
                        );
                        item.maxEligibleQuantity =
                            itemDefNameLower === "embroiderypatch" ? 10 : 99;
                    }
                    // #endregion
                });

                $scope.getBuyXPercentOffNudges();
                return cart;
            });
        };

        $scope.onCouponRemove = function (couponCode) {
            loaderService.show();
            cartService
                .removeCoupon(couponCode)
                .then(function (response) {
                    // Clear the applied coupon state immediately
                    $scope.appliedCoupon = null;
                    $scope.couponValid = false;
                    $scope.coupon = null;
                    $scope.applyCoupon = false;

                    // Remove from localStorage
                    $scope.removeCoupon();

                    // Refresh cart to update totals
                    return $scope
                        .refreshCartAfterCouponOperation()
                        .then(function () {
                            $rootScope.$broadcast("CustomerCartChanged");
                            loaderService.hide();
                        });
                })
                .catch(function (error) {
                    loaderService.hide();
                });
        };

        $scope.onCouponApply = function (couponCode) {
            $scope.couponErrorMessage = "";

            // Early return for empty coupon code
            if (!couponCode || couponCode.trim().length === 0) {
                $scope.couponValid = false;
                return;
            }

            // Error message lookup map
            var errorMessages = {
                "": "Invalid coupon code.",
                usageexceeded: "Coupon already redeemed.",
                restrictedcoupon: "Login to enjoy this coupon.",
                salepricegreater:
                    "Higher discount already applied in your cart.",
            };

            loaderService.show();

            // Simplified coupon object
            var coupon = {
                Code: couponCode.trim(),
                Description: "",
                AppliedSuccessfully: false,
                ErrorCode: "",
            };

            $scope.cart.coupons = coupon;

            return cartService
                .validateCoupon(coupon)
                .then(function (result) {
                    var resultData = result.data;
                    var errorCode = (resultData.errorCode || "").toLowerCase();

                    $scope.appliedCoupon = couponCode.trim();
                    $scope.couponValid = resultData.appliedSuccessfully;
                    $scope.couponErrorMessage =
                        errorMessages[errorCode] || errorMessages[""];

                    if (!$scope.couponValid) {
                        loaderService.hide();
                        return;
                    }

                    // Save to localStorage
                    localStorage.setItem("IsCouponApplied", true);
                    localStorage.setItem("AppliedCoupon", $scope.appliedCoupon);

                    // Add coupon and refresh cart
                    return cartService
                        .addCoupon(resultData.code)
                        .then(function () {
                            return $scope.refreshCartAfterCouponOperation();
                        })
                        .finally(function () {
                            loaderService.hide();
                        });
                })
                .catch(function (error) {
                    $scope.couponValid = false;
                    $scope.couponErrorMessage =
                        "An error occurred while applying the coupon.";
                    loaderService.hide();
                });
        };

        $scope.toggleCouponSection = function (state) {
            $scope.coupon = null;
            $scope.couponValid = null;
            $scope.applyCoupon = state;
        };

        $scope.onCouponKeyPress = function (event) {
            if (event && event.which === 13) {
                $scope.onCouponApply(event.target.value);
            }
        };
        //#endregion

        // #region Quantity related

        $scope.onQtyKeypress = function (e, item, key) {
            var quantity = 1;
            if (angular.isDefined(key)) {
                quantity = item.tempQuantity.toString();
            } else {
                quantity = e.target.value;
            }
            if (isNaN(quantity)) {
                item.tempQuantity = 1;
            } else if (quantity.trim().length < 1 || quantity.trim() == "0") {
                //Do Nothing
            } else {
                quantity = Number(quantity.replace(/ /g, ""));
                if ((e.keyCode == 38 || key == "+") && quantity < 99) {
                    item.tempQuantity = quantity + 1;
                } else if ((e.keyCode == 40 || key == "-") && quantity > 1) {
                    item.tempQuantity = quantity - 1;
                } else {
                    item.tempQuantity = quantity;
                }
            }
        };

        $scope.onQtyUpdate = function (item) {
            $scope.tempQuantityValid = true;
            if (isNaN(item.tempQuantity) || item.tempQuantity == 0) {
                $scope.tempQuantityValid = false;
            } else {
                if (item.tempQuantity.toString().indexOf(" ") > 0) {
                    item.tempQuantity = item.tempQuantity
                        .toString()
                        .replace(/ /g, "");
                }
                if (item.tempQuantity > item.availableQuantity) {
                    $scope.showOutOfStocklbl = true;
                    item.showAvailableQty = true;
                } else {
                    item.showQtyUpdate = false;
                    item.quantity = Number(item.tempQuantity);
                    loaderService.show();
                    updateQuantity(item);
                }
            }
        };

        function updateQuantity(item) {
            if (item.quantity > item.maxEligibleQuantity) {
                item.quantity = item.maxEligibleQuantity;
            }
            cartService
                .changeLineItemQuantity(item.id, item.quantity)
                .then(function (response) {
                    if (response && response.data) {
                        loaderService.hide();
                        $window.location.reload();
                    } else {
                        alert(
                            "Cart has reached Max Limit. Please checkout before adding any more new item's."
                        );
                    }
                });
        }
        //#endregion

        //#region Discount Related
        $scope.getItemDiscount = function (item) {
            if (item.discounts.length > 0) {
                var discountAmt = 0;
                discountAmt = item.discountTotal.internalAmount;
                return discountAmt;
            }
            return 0;
        };

        $scope.onShowDiscountsClick = function (item) {
            item.showDiscountsContent = !item.showDiscountsContent;
        };
        //#endregion

        //#region Delete cart item
        $scope.removeLineItem = function (lineItemId) {
            loaderService.show();
            var lineItem = _.find($scope.cart.items, function (i) {
                return i.id == lineItemId;
            });
            if (!lineItem || $scope.cartIsUpdating) {
                return;
            }
            var initialItems = angular.copy($scope.cart.items);
            $scope.cart.items = _.without($scope.cart.items, lineItem);
            cartService.removeLineItem(lineItemId).then(
                function (response) {
                    $scope.getCart();
                    $scope.toggleCouponSection(false);
                    $scope.removeCoupon();
                    $rootScope.$broadcast("CustomerCartChanged");

                    //GA 4
                    if (
                        typeof gtag !== "undefined" &&
                        gtag !== null &&
                        $scope.cart.items != null
                    ) {
                        cartObj = {
                            currency: "USD",
                            affiliation: "EmbroideryDesigns.com",
                            price: lineItem.salePrice.amount,
                            items: [],
                        };

                        if (
                            $scope.cart.items != null &&
                            $scope.cart.items.length > 0 &&
                            lineItem != null
                        ) {
                            cartObj.items.push({
                                item_name: lineItem.name,
                                item_id: lineItem.sku,
                                item_category: lineItem.definitionName,
                                quantity: lineItem.quantity,
                            });
                        }

                        gtag("event", "remove_from_cart", cartObj);
                        if (typeof window.trackBing === "function") {
                            window.trackBing("remove_from_cart", {
                                revenue_value: lineItem.salePrice.amount,
                                currency: "USD",
                                event_label: lineItem.sku,
                            });
                        }
                    }
                    //End Region
                },
                function (response) {
                    $scope.cart.items = initialItems;
                    loaderService.hide();
                    $scope.cartIsUpdating = false;
                }
            );
        };
        //#endregion

        //#region Submit Cart
        $scope.CheckoutCart = function () {
            var url = "/cart/checkout/shipping";
            var isGuestUser = false;
            isGuestUser =
                $scope.customer &&
                $scope.customer.contact &&
                $scope.customer.contact.salutation &&
                $scope.customer.contact.salutation.toLowerCase() == "guest";
            if (
                $rootScope.currencyConversion.displayCurrency &&
                $rootScope.currencyConversion.localCurrency &&
                $rootScope.currencyConversion.displayCurrency ==
                    $rootScope.currencyConversion.localCurrency
            ) {
                $scope.shippingMethods.showModal = false;
                modalService.open("confirmCurrencyConverterExit");
                $rootScope.currencyConversion.redirectUrl = url;
            } else {
                if (
                    $scope.customer &&
                    $scope.customer.isRegisteredUser &&
                    !isGuestUser
                ) {
                    $window.location.href = url;
                } else
                    $rootScope.$emit("ShowNotificationModal", {
                        modalKey: "loginOptions",
                    });
            }
        };
        //#endregion

        // #region Product Related

        // #region Physical Products
        function getPhysicalProducts(data) {
            return data.filter(function (elm) {
                return (
                    elm.productType &&
                    elm.productType.toLowerCase() == "physical"
                );
            });
        }

        $scope.cartHasPhysicalProduct = function () {
            return $scope.cart.items.some(function (item) {
                return (
                    item.productType &&
                    item.productType.toLowerCase() == "physical"
                );
            });
        };
        // #endregion

        // #region GiftCertificate Products
        function getGiftCertificate(data) {
            return data.filter(function (elm) {
                return elm.catalogId.toLowerCase() == "gift certificates";
            });
        }

        $scope.isCartHasOnlyGC = function () {
            var giftCertificate = getGiftCertificate($scope.cart.items);
            if (giftCertificate.length == $scope.cart.items.length) {
                return true;
            } else {
                return false;
            }
        };
        // #endregion

        //#region Product Inventory
        function checkProductsAvailability(prdInfo, inventoryInfo) {
            angular.forEach(prdInfo, function (prd) {
                if (prd.productType.toLowerCase() == "physical") {
                    var results = inventoryInfo.filter(function (p) {
                        return (
                            p.productId.toLowerCase() ==
                            prd.productId.toLowerCase()
                        );
                    });
                    if (results && results.length > 0) {
                        if (results[0].status != 0) {
                            prd.availableQuantity = results[0].inStockQuantity;
                        } else {
                            prd.availableQuantity = 0;
                        }
                    }
                    if (prd.quantity > prd.availableQuantity) {
                        $scope.showOutOfStocklbl = true;
                    }
                }
            });
        }

        function getProductsInventory() {
            if (
                angular.isDefined($scope.cart) &&
                angular.isDefined($scope.cart.items) &&
                $scope.cart.items.length > 0
            ) {
                var physicalProducts = getPhysicalProducts($scope.cart.items);
                if (
                    angular.isDefined(physicalProducts) &&
                    physicalProducts.length > 0
                ) {
                    var prdIds = _.pluck(physicalProducts, "productId");
                    productService
                        .getProductsInventory(prdIds)
                        .then(function (response) {
                            if (response && response.data) {
                                checkProductsAvailability(
                                    $scope.cart.items,
                                    response.data
                                );
                            }
                        });
                }
            }
        }
        //#endregion

        //#endregion

        //#region Shipping related
        $scope.destChange = function () {
            $rootScope.selectedDest = document.getElementById("dest").value;

            if ($rootScope.selectedDest.toLowerCase() == "intl") {
                $rootScope.selectedDest = "Intl";
                $rootScope.selectedCountry = $rootScope.countries[0];
            } else if ($rootScope.selectedDest.toLowerCase() == "us") {
                $rootScope.selectedDest = "US";
            } else {
                $rootScope.selectedDest = $rootScope.selectedDest;
            }
        };

        $scope.showEstimateShipping = function () {
            $rootScope.isUSShipping = true;
            $rootScope.gotEstimate = false;
            $rootScope.shippingErrors = false;
            $rootScope.shippingEstimate = 0.0;
            $rootScope.selectedDest = "US";

            if (
                $rootScope.countries == undefined ||
                ($rootScope.countries && $rootScope.countries.length < 1)
            ) {
                commonService.getCountries().then(function (response) {
                    $rootScope.countries = response.data.filter(function (x) {
                        return x.code2 != "US";
                    });
                    $rootScope.selectedCountry = $rootScope.countries[0];
                });
            }

            accountService.getCurrentCustomer().then(function (result) {
                $rootScope.customerAddresses = result.data.addresses;

                if (
                    $rootScope.customerAddresses != null &&
                    $rootScope.customerAddresses.length > 0
                ) {
                    $rootScope.selectedDest =
                        $rootScope.customerAddresses[0].key;
                }

                $scope.toggleModal("shippingEstimate", true);

                $scope.destChange();
            });
        };

        $scope.getCartShippingEstimate = function () {
            var address = {};
            $rootScope.gotEstimate = false;
            $scope.hasShippingErrors = false;
            $scope.invalidPostalCode = false;
            if ($rootScope.selectedDest.toLowerCase() == "us") {
                var zipCode = document.getElementById("zipCode").value;
                address.postalCode = zipCode;
                address.countryName = "United States";
                address.countryCode = "US";
                if (address.postalCode == "") {
                    $scope.hasShippingErrors = true;
                } else if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode)) {
                    $scope.invalidPostalCode = true;
                }
            } else if ($rootScope.selectedDest.toLowerCase() == "intl") {
                $scope.hasShippingErrors = false;
                address.countryName = $scope.selectedCountry.name;
                address.countryCode = $scope.selectedCountry.code2;
            } else {
                $rootScope.customerAddresses.forEach(function (addr) {
                    if (
                        addr.key.toLowerCase() ==
                        $rootScope.selectedDest.toLowerCase()
                    ) {
                        address.postalCode = addr.postalCode;
                        address.countryName = addr.countryName;
                        address.countryCode = addr.countryCode;

                        if (addr.countryCode.toLowerCase() != "us") {
                            address.postalCode = null;
                        }
                    }
                });
            }

            if (!$scope.hasShippingErrors && !$scope.invalidPostalCode) {
                loaderService.show();
                if (
                    angular.isDefined($scope.isCouponApplied) &&
                    $scope.isCouponApplied
                ) {
                    address.CouponCode = $scope.isCouponApplied
                        ? $scope.couponCode
                        : "";
                }
                cartService
                    .getCartShippingEstimate(address)
                    .then(function (result) {
                        $rootScope.shippingEstimate = result.data.totalShipping;
                        $rootScope.vendorNotShipping =
                            result.data.vendorNotShipping;
                        $rootScope.invalidPostalCode =
                            result.data.invalidPostalCode;
                        // $scope.cartAndShipping = $scope.cart.subTotal.amount + $scope.shippingEstimate;
                        $rootScope.gotEstimate = true;
                        loaderService.hide();
                    });
            }
        };

        $scope.countryChange = function (selectedCountry) {
            $scope.selectedCountry = selectedCountry;
        };

        $scope.resetEstimateModal = function (key) {
            $rootScope.isUSShipping = true;
            $rootScope.gotEstimate = false;
            $rootScope.shippingErrors = false;
            $rootScope.shippingEstimate = 0.0;
            $rootScope.selectedDest = "US";

            $scope.toggleModal(key);
        };

        $scope.ChooseShippingMethod = function () {
            if (!$scope.showOutOfStocklbl) {
                var physicalProducts = getPhysicalProducts($scope.cart.items);
                if (
                    angular.isDefined(physicalProducts) &&
                    physicalProducts.length > 0
                ) {
                    var prdIds = _.pluck(physicalProducts, "productId");
                    productService
                        .getProductsInventory(prdIds)
                        .then(function (response) {
                            if (response) {
                                checkProductsAvailability();
                                if (!$scope.showOutOfStocklbl) {
                                    $scope.CheckoutCart();
                                } else {
                                    $scope.showOutOfStocklbl = true;
                                }
                            }
                        });
                } else {
                    $scope.CheckoutCart();
                }
            } else {
                alert(
                    "There are item(s) in your shopping cart which are currently out of stock. If you wish to proceed for checkout, simply update the quantity or remove the out of stock item(s) form your cart."
                );
            }
        };
        //#endregion

        //#region Other Helper Functions

        $scope.removeFromFavorite = function (defName) {
            return (
                ["giftcertificate", "customdigitizing"].indexOf(
                    defName.toLowerCase()
                ) > -1
            );
        };

        function filterAllSelectedItems(removeFromFavorite) {
            var selectedItems = [];
            angular.forEach($scope.cart.items, function (item) {
                if (
                    removeFromFavorite &&
                    $scope.removeFromFavorite(item.definitionName)
                ) {
                    item.isSelected = false;
                }
                if (item.isSelected) {
                    selectedItems.push(item);
                }
            });
            return selectedItems;
        }

        $scope.getItemPrice = function (item) {
            if (
                item.productType &&
                item.productType.toLowerCase() == "physical"
            ) {
                return item.placedPrice.amount * item.quantity;
            } else {
                return item.placedPrice.amount;
            }
        };

        /// Unit price for display: ListPrice + StitchPlanPrice when stitch plan included, else ListPrice.
        $scope.getItemUnitPriceWithStitchPlan = function (item) {
            if (!item || !item.listPrice) return 0;
            var unit = item.listPrice.amount || 0;
            if (item.stitchPlanIncluded && item.stitchPlanPrice && item.stitchPlanPrice.amount != null) {
                unit += item.stitchPlanPrice.amount;
            }
            return unit;
        };

        /// Line total for display: (PlacedPrice + StitchPlanPrice) * Quantity when stitch plan included, else getItemPrice(item).
        $scope.getItemTotalWithStitchPlan = function (item) {
            if (!item) return 0;
            if (item.stitchPlanIncluded && item.stitchPlanPrice && item.stitchPlanPrice.amount != null) {
                var perUnit = (item.placedPrice && item.placedPrice.amount != null ? item.placedPrice.amount : 0) + item.stitchPlanPrice.amount;
                if (item.productType && item.productType.toLowerCase() === "physical") {
                    return perUnit * (item.quantity || 1);
                }
                return perUnit;
            }
            return $scope.getItemPrice(item);
        };

        $scope.getPrdUrl = function (item, cart) {
            item.cartId = cart.id;
            return urlService.getProductUrl(item);
        };

        $scope.getPrdImageUrl = function (item) {
            item.showThreadVariants = true;
            item.ilLineItems = [];
            item.ilLineItems.push(item.instantLetteringItems[0]);
            item.pdLineItems = [];
            item.pdLineItems.push(item.cartLineItemCustomProperties[0]);
            var imageUrl = urlService.getImageUrl(item);
            if (
                item.definitionName.toLowerCase() ==
                catalogService.productDefinition.giftCertificate.toLowerCase()
            ) {
                imageUrl += item.giftCardItems[0].giftCardImage;
            }
            return imageUrl;
        };

        $scope.getNumber = function (num) {
            return new Array(num);
        };

        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            } else {
                modalService.close(key);
            }
        };

        $scope.getPinnacleBrandListingUrl = function () {
            var path =
                "stockdesign/brands/pinnacle-embroidery-patterns#/?pg=1&sort=newest&ipp=60&view=grid&brd=pinnacle-embroidery-patterns&prdtype=stockdesign&availability=in-stock";
            var b = (
                ($scope.baseUrl || $rootScope.baseUrl || "") + ""
            ).replace(/\/+$/, "");
            if (!b) {
                return "/" + path;
            }
            return b + "/" + path;
        };

        function isPinnacleCatalogName(catalogOrBrand) {
            var normalized = (catalogOrBrand || "")
                .toString()
                .toLowerCase()
                .replace(/[\s\-_]/g, "");
            return normalized.indexOf("pinnacle") > -1;
        }

        function isPinnacleQualifyingDefinition(definitionName) {
            var def = (definitionName || "").toLowerCase();
            return def === "stockdesign" || def === "fontletter";
        }

        function getCartItemExtendedListPriceAmount(item) {
            if (
                item &&
                item.extendedListPrice &&
                item.extendedListPrice.amount != null
            ) {
                return item.extendedListPrice.amount;
            }
            return 0;
        }

        function isPinnaclePaidQualifyingCartItem(item) {
            if (!item || !isPinnacleQualifyingDefinition(item.definitionName)) {
                return false;
            }
            if (isPinnacleCatalogName(item.catalogId || item.brand)) {
                return false;
            }
            return getCartItemExtendedListPriceAmount(item) > 0;
        }

        function getPinnaclePaidDesignCount() {
            if (
                !$scope.cart ||
                !angular.isArray($scope.cart.items) ||
                !$scope.cart.items.length
            ) {
                return 0;
            }
            return $scope.cart.items.reduce(function (total, item) {
                if (!isPinnaclePaidQualifyingCartItem(item)) {
                    return total;
                }
                return total + (item.quantity || 1);
            }, 0);
        }

        $scope.getPinnacleFreeDesignCount = function () {
            return getPinnaclePaidDesignCount() * 2;
        };

        $scope.getPinnacleFreeDesignButtonText = function () {
            var count = $scope.getPinnacleFreeDesignCount();
            if (count === 1) {
                return "Choose My 1 Free Design";
            }
            return "Choose My " + count + " Free Designs";
        };

        $scope.trackPinnacleFreeDesignClick = function () {
            if (typeof gtag !== "undefined" && gtag !== null) {
                gtag("event", "cart_pinnacle_free_design_click", {
                    event_category: "engagement",
                    event_action: "cart_pinnacle_promo_click",
                    event_label: $scope.getPinnacleFreeDesignButtonText(),
                    free_design_count: $scope.getPinnacleFreeDesignCount(),
                    paid_design_count: getPinnaclePaidDesignCount(),
                });
            }
        };

        $scope.isPinnacleOfferEligible = function () {
            var pinnacleSettings =
                $window.__env && $window.__env.pinnacleSectionSettings;
            if (
                pinnacleSettings &&
                pinnacleSettings.cartPage === false
            ) {
                return false;
            }
            if (
                angular.isDefined($scope.cart) &&
                angular.isDefined($scope.cart.subTotal)
            ) {
                return (
                    getPinnaclePaidDesignCount() > 0 &&
                    $scope.cart.subTotal.amount > 0
                );
            }
            return false;
        };
        //#endregion

         //#region Embrilliance cart section (display only when cart has Embrilliance products)
         $scope.embrillianceCartFontPacks = [];
         $scope.embrillianceCartBundles = [];
 
         function applyEmbrillianceCartSplit(list) {
             var arr = list || [];
             var fonts = [];
             var bundles = [];
             arr.forEach(function (h) {
                 var def = (h._source && h._source.definitionName ? h._source.definitionName : "").toLowerCase();
                 if (def === "fontpack" && fonts.length < 3) fonts.push(h);
                 else if ((def === "designpack" || def === "projectpack") && bundles.length < 3) bundles.push(h);
             });
             $scope.embrillianceCartFontPacks = fonts;
             $scope.embrillianceCartBundles = bundles;
         }

         function cartItemToHit(item) {
            var id = (item.productId || item.id || "").toString();
             return {
                 _source: {
                    itemId: id,
                    name: item.name || "",
                    catalog: item.catalogId || "",
                     listPrice: item.listPrice && item.listPrice.amount != null ? item.listPrice.amount : (item.listPrice || 0),
                     salePrice: (item.salePrice && item.salePrice.amount != null ? item.salePrice.amount : null) || (item.listPrice && item.listPrice.amount != null ? item.listPrice.amount : null),
                     clubPrice: (item.clubPrice && item.clubPrice.amount != null ? item.clubPrice.amount : null) || 0,
                    variants: item.variants || [],
                    definitionName: item.definitionName || "",
                     rating: item.rating != null ? item.rating : 0,
                     saleRank: item.saleRank != null ? item.saleRank : 0,
                     videoParts: item.videoParts,
                     runTime: item.runTime
                 }
             };
         }
 
         function fillEmbrillianceFromCart() {
             var items = ($scope.cart && $scope.cart.items) ? $scope.cart.items : [];
             var fontIds = {};
             var bundleIds = {};
             $scope.embrillianceCartFontPacks.forEach(function (h) {
                var id = (h._source && h._source.itemId || "").toString().toLowerCase();
                 if (id) fontIds[id] = true;
             });
             $scope.embrillianceCartBundles.forEach(function (h) {
                var id = (h._source && h._source.itemId || "").toString().toLowerCase();
                 if (id) bundleIds[id] = true;
             });
             items.forEach(function (item) {
                 var def = (item.definitionName || "").toLowerCase();
                var id = (item.productId || item.id || "").toString().toLowerCase();
                 if (!id) return;
                 if (def === "fontpack" && $scope.embrillianceCartFontPacks.length < 3 && !fontIds[id]) {
                     $scope.embrillianceCartFontPacks.push(cartItemToHit(item));
                     fontIds[id] = true;
                 } else if ((def === "designpack" || def === "projectpack") && $scope.embrillianceCartBundles.length < 3 && !bundleIds[id]) {
                     $scope.embrillianceCartBundles.push(cartItemToHit(item));
                     bundleIds[id] = true;
                 }
             });
         }
 
         function fillEmbrillianceFontAndBundleRecommendations (combinedList, cartProductIds) {
             applyEmbrillianceCartSplit(combinedList || []);
             var needFonts = Math.max(0, 3 - $scope.embrillianceCartFontPacks.length);
             var needBundles = Math.max(0, 3 - $scope.embrillianceCartBundles.length);
             var existingIds = {};
             $scope.embrillianceCartFontPacks.concat($scope.embrillianceCartBundles).forEach(function (h) {
                 var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                 if (id) existingIds[id] = true;
             });
             if (cartProductIds && cartProductIds.length) {
                 cartProductIds.forEach(function (id) {
                     var key = (id || "").toString().toLowerCase();
                     if (key) existingIds[key] = true;
                 });
             }
             var promise = $q.when();
             if (needFonts > 0) {
                 promise = promise.then(function () {
                     return elasticService
                         .getElasticData(
                             elasticService.buildEmbrillianceStarterPacksRequest(10, ["FontPack"])
                         )
                         .then(function (res) {
                             var hits =
                                 res && res.data && res.data.hits && res.data.hits.hits
                                     ? res.data.hits.hits
                                     : [];
                             for (var i = 0; i < hits.length && $scope.embrillianceCartFontPacks.length < 3; i++) {
                                 var h = hits[i];
                                 var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                                 if (id && !existingIds[id]) {
                                     $scope.embrillianceCartFontPacks.push(h);
                                     existingIds[id] = true;
                                 }
                             }
                         });
                 });
             }
             if (needBundles > 0) {
                 promise = promise.then(function () {
                     return elasticService
                         .getElasticData(
                             elasticService.buildEmbrillianceStarterPacksRequest(10, [
                                 "DesignPack",
                                 "ProjectPack",
                             ])
                         )
                         .then(function (res) {
                             var hits =
                                 res && res.data && res.data.hits && res.data.hits.hits
                                     ? res.data.hits.hits
                                     : [];
                             for (var i = 0; i < hits.length && $scope.embrillianceCartBundles.length < 3; i++) {
                                 var h = hits[i];
                                 var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                                 if (id && !existingIds[id]) {
                                     $scope.embrillianceCartBundles.push(h);
                                     existingIds[id] = true;
                                 }
                             }
                         });
                 });
             }
             return promise;
         }
 
         $scope.cartHasEmbrillianceProduct = function () {
             if (
                 angular.isDefined($scope.cart) &&
                 angular.isDefined($scope.cart.items) &&
                 $scope.cart.items.length > 0
             ) {
                 return $scope.cart.items.some(function (item) {
                    var catalog = (item.catalogId || "").trim().toLowerCase();
                    var definitionName = (item.definitionName || "").trim().toLowerCase();
                    return catalog === "briton leap" && definitionName === "software";
                 });
             }
             return false;
         };
 
         function loadEmbrillianceCartRecommendations() {
             var cartProductIds = [];
             if ($scope.cart && $scope.cart.items && $scope.cart.items.length) {
                 $scope.cart.items.forEach(function (item) {
                    var id = (item.productId || item.id || "").toString().toLowerCase();
                    if (id) cartProductIds.push(id);
                 });
             }
             var embrillianceCartProductIds =
                 window.__env &&
                 window.__env.embrillianceCartProductIds &&
                 window.__env.embrillianceCartProductIds.length
                     ? window.__env.embrillianceCartProductIds
                     : [];
             var targetCount = 6;
 
             function filterOutCartIds(hits) {
                 if (!cartProductIds.length) return hits || [];
                 var set = {};
                 cartProductIds.forEach(function (id) { set[id] = true; });
                var filtered = (hits || []).filter(function (h) {
                     var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                     return !id || !set[id];
                 });
                 return filtered;
             }
 
             function setFallbackRecommendations() {
                 return elasticService
                     .getElasticData(
                         elasticService.buildEmbrillianceStarterPacksRequest(targetCount, [
                             "ProjectPack",
                             "FontPack",
                             "DesignPack",
                         ])
                     )
                     .then(function (fallbackResponse) {
                         var raw = (fallbackResponse && fallbackResponse.data && fallbackResponse.data.hits && fallbackResponse.data.hits.hits)
                             ? fallbackResponse.data.hits.hits.slice(0, targetCount)
                             : [];
                         return fillEmbrillianceFontAndBundleRecommendations (filterOutCartIds(raw), cartProductIds);
                     })
                     .then(function () { fillEmbrillianceFromCart(); });
             }
 
             if (embrillianceCartProductIds.length === 0) {
                 setFallbackRecommendations();
                 return;
             }
 
             elasticService
                 .getElasticData(
                     elasticService.buildProductByIdsRequest(angular.toJson(embrillianceCartProductIds))
                 )
                 .then(function (response) {
                     var hits =
                         response &&
                         response.data &&
                         response.data.hits &&
                         response.data.hits.hits
                             ? response.data.hits.hits
                             : [];
 
                     var idToHit = {};
                     hits.forEach(function (h) {
                         var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                         if (id) idToHit[id] = h;
                     });
                     var ordered = [];
                     embrillianceCartProductIds.forEach(function (id) {
                         var key = id.toLowerCase();
                         if (idToHit[key]) ordered.push(idToHit[key]);
                     });
                     ordered = filterOutCartIds(ordered);
                     var needCount = targetCount - ordered.length;
                     if (needCount <= 0) {
                         return fillEmbrillianceFontAndBundleRecommendations (ordered.slice(0, targetCount), cartProductIds)
                             .then(function () { fillEmbrillianceFromCart(); });
                     }
 
                     var existingIds = {};
                     ordered.forEach(function (h) {
                         var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                         if (id) existingIds[id] = true;
                     });
                     var cartIdSet = {};
                     cartProductIds.forEach(function (id) {
                         var key = (id || "").toString().toLowerCase();
                         if (key) cartIdSet[key] = true;
                     });
 
                     elasticService
                         .getElasticData(
                             elasticService.buildEmbrillianceStarterPacksRequest(targetCount + needCount, [
                                 "ProjectPack",
                                 "FontPack",
                                 "DesignPack",
                             ])
                         )
                         .then(function (fallbackResponse) {
                             var fallbackHits =
                                 fallbackResponse &&
                                 fallbackResponse.data &&
                                 fallbackResponse.data.hits &&
                                 fallbackResponse.data.hits.hits
                                     ? fallbackResponse.data.hits.hits
                                     : [];
                             var filler = [];
                            for (var i = 0; i < fallbackHits.length && filler.length < needCount; i++) {
                                 var h = fallbackHits[i];
                                 var id = (h._id || (h._source && h._source.itemId) || "").toString().toLowerCase();
                                if (id && !existingIds[id] && !cartIdSet[id]) {
                                     filler.push(h);
                                     if (id) existingIds[id] = true;
                                 }
                             }
                             return fillEmbrillianceFontAndBundleRecommendations (
                                 ordered.concat(filler).slice(0, targetCount),
                                 cartProductIds
                             );
                         })
                         .then(function () { fillEmbrillianceFromCart(); });
                 });
         }
         //#endregion

        //#region Instant Lettering
        $scope.addILItemToCart = function () {
            var ilItem = {
                RequestId: "",
                TemplateId: "",
                Recipe: "",
                IsStitchCenterOut: "false",
                IsTwoLines: "false",
                Line1Text: "",
                Line1Font: "",
                Line1FontSize: 0,
                Line1Color: "",
                Line2Text: "",
                Line2Font: "",
                Line2FontSize: 0,
                Line2Color: "",
                SpacingBetweenLines: 0,
                Justify: "",
                Height: 0,
                Width: 0,
                DownloadFormat: "",
                ThreadManufacturer: "",
            };
            cartService
                .addInstantLetteringItemToCart(ilItem)
                .then(function (response) {
                    $rootScope.$broadcast("CustomerCartChanged");
                });
        };
        //#endregion

        //#region Select All, Unselect All
        $scope.checkUncheckAll = function (isAllChecked) {
            angular.forEach($scope.cart.items, function (item) {
                item.isSelected = isAllChecked;
            });
        };

        $scope.deleteBulkItemsFromCart = function (selectedItems) {
            if (
                confirm("Are you sure you want to Delete all selected item(s)?")
            ) {
                var selectedItemIds = _.pluck(selectedItems, "id");
                var initialItems = angular.copy($scope.cart.items);
                cartService.removeLineItems(selectedItemIds).then(
                    function () {
                        $scope.getCart();
                        $scope.toggleCouponSection(false);
                        $scope.removeCoupon();
                        $rootScope.$broadcast("CustomerCartChanged");
                    },
                    function () {
                        $scope.cart.items = initialItems;
                        $scope.cartIsUpdating = false;
                    }
                );
            }
            $scope.selectedAction = "";
        };

        $scope.toggleNewFavoritesGroupModal = function (status, sku) {
            $rootScope.newFavoritesSKU = angular.isDefined(sku) ? sku : [];
            if (status) {
                modalService.open("favorites-group");
            } else {
                modalService.close("favorites-group");
                $rootscope.$emit("NewFavoritesGroupModalClosed");
            }
        };

        $scope.updateItemsFavoritesGroup = function (selectedItems) {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                if (
                    confirm(
                        "Are you sure you want to move all selected item(s)?"
                    )
                ) {
                    $rootScope.selectedItems = [];
                    angular.forEach(selectedItems, function (item) {
                        $rootScope.selectedItems.push(item.productId);
                    });
                    if (angular.isDefined($rootScope.selectedItems)) {
                        $rootScope.newFavoritesSKU =
                            $rootScope.selectedItems.join(",");
                    }
                    $scope.toggleNewFavoritesGroupModal(
                        true,
                        $rootScope.newFavoritesSKU
                    );
                    $scope.selectedAction = "";
                }
            } else {
                var returnURL =
                    $window.location.pathname + $window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        $scope.onMultiSelectActionChange = function (action) {
            $scope.selectedAction = "";
            var selectedItems = filterAllSelectedItems();
            if (selectedItems.length > 0) {
                switch (action) {
                    case "Delete":
                        $scope.deleteBulkItemsFromCart(selectedItems);
                        break;
                    case "MoveToList":
                        selectedItems = filterAllSelectedItems(true);
                        if (selectedItems && selectedItems.length > 0) {
                            $scope.updateItemsFavoritesGroup(selectedItems);
                        }
                        break;
                    default:
                        break;
                }
                $scope.isAllChecked = false;
                $scope.checkUncheckAll(false);
            } else {
                alert("please select atleast one item to proceed..");
            }
        };
        //#endregion
        //#region   Club Membership
        $scope.selectPlan = function (planTenure) {
            $scope.selectedPlan = planTenure.toString(); // Set the selected plan value
        };
        $scope.getMembershipPlans = function () {
            membershipService.getMembershipPlans().then(function (response) {
                if (response && response.data) {
                    $rootScope.membershipPlans = response.data;
                    $scope.selectedPlan =
                        response.data[0].planTenure.toString();
                }
            });
        };

        $scope.onMembershipModalInit = function () {
            if (
                $rootScope.isMembershipInfoAvailable == false ||
                angular.isUndefined($rootScope.isMembershipInfoAvailable)
            ) {
                $scope.getMembershipPlans();
                $rootScope.isMembershipInfoAvailable = true;
            }
        };

        $scope.onMembershipCheckout = function () {
            $rootScope.showLoader = true;
            if ($scope.selectedPlan) {
                var planToCheckout = $rootScope.membershipPlans.filter(
                    function (plan) {
                        return plan.planTenure == $scope.selectedPlan;
                    }
                );
                if (angular.isDefined(planToCheckout)) {
                    $rootScope.showLoader = true;
                    $scope.toggleModal("mdlCircle", false);
                    cartService
                        .addMembershipCart(
                            planToCheckout[0].planId,
                            planToCheckout[0].planTenure
                        )
                        .then(function (response) {
                            if (response && response.data) {
                                $rootScope.showLoader = false;
                                $window.location.href = "/cart/checkout";
                            } else {
                                $rootScope.showLoader = false;
                                $window.location.href =
                                    "/account/login?ReturnUrl=/embroidery-circle";
                            }
                        });
                } else {
                    alert("Please select a valid Plan");
                }
            } else {
                alert("Please select a valid Plan");
            }
        };

        function getClubPriceTotal() {
            function getClubPrice(listPrice, salePrice, clubPrice) {
                listPrice = listPrice != undefined ? Number(listPrice) : null;
                salePrice = salePrice != undefined ? Number(salePrice) : null;
                clubPrice = clubPrice != undefined ? Number(clubPrice) : null;
                if (salePrice != null) {
                    if (clubPrice != null) {
                        if (salePrice < clubPrice) return salePrice;
                        else return clubPrice >= 0 ? clubPrice : salePrice;
                    } else return salePrice;
                } else if (clubPrice != null)
                    return clubPrice >= 0 ? clubPrice : listPrice;
                else return listPrice;
            }
            function getItemQuantity(itemId) {
                var quantity = 1;

                var filteredResults = $scope.cart.items.filter(function (item) {
                    return item.productId.toLowerCase() == itemId.toLowerCase();
                });
                if (filteredResults.length > 0) {
                    quantity = filteredResults
                        .map(function (c) {
                            return c.quantity;
                        })
                        .reduce(function (a, b) {
                            return a + b;
                        }, 0);
                }

                return quantity;
            }
            var productIds = [];
            var idsToRemove = [];

            // if (configs && configs.giftCardProductIds) {
            //     idsToRemove = configs.giftCardProductIds;
            // }
            // if (configs && configs.customDigitizingProductIds) {
            //     idsToRemove = idsToRemove.concat(configs.customDigitizingProductIds);
            // }
            clubPriceTotal = 0;
            $scope.cart.items.forEach(function (item) {
                // checking for Giftcards and Custom Digitizing items
                if (idsToRemove.indexOf(item.productId.toLowerCase()) > -1) {
                    clubPriceTotal = clubPriceTotal + item.salePrice.amount;
                }
                //adding other Ids
                else {
                    productIds.push(item.productId);
                }
            });
            if (productIds && productIds.length > 0) {
                // Removing variantid from SKU for elastic query
                var strProductIds = productIds
                    .map(function (id) {
                        return id.split(/_var_/gi)[0];
                    })
                    .join('","');
                elasticService
                    .getElasticData(
                        elasticService.buildClubPricesTotalRequest(
                            strProductIds
                        )
                    )
                    .then(function (response) {
                        if (response.data) {
                            var items =
                                response.data.aggregations.items.hits.hits;
                            if (items && items.length > 0) {
                                productIds.forEach(function (id) {
                                    variantId = undefined;
                                    if (
                                        id.toLowerCase().indexOf("_var_") > -1
                                    ) {
                                        variantId = id.split(/_var_/gi)[1];
                                        itemId = id.split(/_var_/gi)[0];
                                    } else {
                                        itemId = id;
                                    }
                                    item = items.filter(function (i) {
                                        return i._id.toLowerCase() == itemId;
                                    });
                                    if (item && item.length > 0) {
                                        item = item[0]._source;
                                        if (variantId) {
                                            item = item.variants.filter(
                                                function (v) {
                                                    return (
                                                        v.variantId == variantId
                                                    );
                                                }
                                            )[0];
                                        }
                                        var clubPrice = getClubPrice(
                                            item.listPrice,
                                            item.salePrice,
                                            item.clubPrice
                                        );
                                        clubPriceTotal =
                                            clubPriceTotal +
                                            getItemQuantity(id) * clubPrice;
                                        $scope.clubPriceTotal = clubPriceTotal;
                                    }
                                });
                            }
                        }
                        //($scope.cart.discountTotal.amount - $scope.cart.discountAmount.amount) -> to calculate cart level discounts
                        $scope.membershipSavings = Number(
                            (
                                $scope.cart.subTotal.amount -
                                ($scope.cart.discountTotal.amount -
                                    $scope.cart.discountAmount.amount) -
                                $scope.clubPriceTotal
                            ).toFixed(2)
                        );
                    });
            } else {
                $scope.clubPriceTotal = undefined;
                $scope.membershipSavings = undefined;
            }
        }

        //#endregion

        var PAYPAL_MIN_AMOUNT = 25;

        function updateCartPaypalAmount(amount, previousAmount) {
            if (amount < PAYPAL_MIN_AMOUNT) {
                return;
            }
            $timeout(function () {
                var paypalContainer = document.getElementById(
                    "paypal-messaging-container-cr"
                );
                if (!paypalContainer) {
                    return;
                }
                paypalContainer.setAttribute("data-pp-amount", amount);
                var wasBelowMin =
                    previousAmount == null || previousAmount < PAYPAL_MIN_AMOUNT;
                var notYetRendered =
                    paypalContainer.getAttribute("data-ecom-pp-rendered") !==
                    "1";
                if (
                    (wasBelowMin || notYetRendered) &&
                    typeof window.__ecomRenderPayPalMessageFor === "function"
                ) {
                    window.__ecomRenderPayPalMessageFor(paypalContainer);
                }
            });
        }
    },
]);
